import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-project-timeline-sidebar', {
  mixins: [eventListenerMixin],

  connected() {
    this.timeline = document.querySelector('tr-project-timeline');

    [].forEach.call(this.querySelectorAll('[data-hover-id]'), (el) => {
      this.listenTo(el, {
        mouseenter: () => {
          const todo = this.timeline.querySelector(`#${el.dataset.hoverId}`);
          if (todo) todo.classList.add('hover');
        },
        mouseleave: () => {
          const todo = this.timeline.querySelector(`#${el.dataset.hoverId}`);
          if (todo) todo.classList.remove('hover');
        },
      });
    });

    [].forEach.call(this.querySelectorAll('.sidebar-group-title'), (title) => {
      this.listenTo(title, 'click', this.handleToggleGroup.bind(this));
    });

    [].forEach.call(this.querySelectorAll('.sidebar-todo'), (sidebarTodo) => {
      this.listenTo(sidebarTodo, 'click', this.handleClickTodo.bind(this));
    });

    this.initResizer();
  },

  initResizer() {
    this.resizer = this.querySelector('.resizer');
    const maxWidth = window.innerWidth / 2;
    const minWidth = 150;

    const resize = (event) => {
      const width = event.pageX - this.getBoundingClientRect().left;
      if (width < minWidth || width > maxWidth) return;
      this.namespacedTrigger('resize', { detail: width });
    };

    const stopResize = (event) => {
      const width = event.pageX - this.getBoundingClientRect().left;
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', stopResize);
      this.namespacedTrigger('stopResize', { detail: width });
      this.classList.remove('resizing');
    };

    this.listenTo(this.resizer, 'mousedown', (event) => {
      event.preventDefault();
      this.classList.add('resizing');
      window.addEventListener('mousemove', resize);
      window.addEventListener('mouseup', stopResize);
    });
  },

  handleToggleGroup(event) {
    const sidebarGroup = closest(event.target, '.sidebar-group');
    this.toggleGroup(sidebarGroup);
    this.setStorage();
  },

  handleClickTodo(event) {
    const { todoId } = event.currentTarget.dataset;
    const todo = this.timeline.querySelector(
      `tr-project-timeline-todo[todo-id="${todoId}"] .timeline-todo-wrapper`,
    );
    if (!todo) return;

    let left = todo.offsetLeft - 96;
    if (left < 0) left = 0;
    this.timeline.querySelector('.timeline-container').scrollLeft = left;
    todo.classList.add('highlight');
    setTimeout(() => todo.classList.remove('highlight'), 400);
  },

  toggleGroup(sidebarGroup) {
    const id = sidebarGroup.dataset.groupId;
    const group = this.timeline.querySelector(`tr-project-timeline-group[group-id="${id}"]`);
    if (!group) return;
    sidebarGroup.classList.toggle('fold-group');
    group.toggle();
  },

  setStorage() {
    const cacheKey = `${window.location.pathname}timeline_group_toggle`;
    const storage = [].map
      .call(this.querySelectorAll('.fold-group'), group => group.dataset.groupId)
      .join(',');
    window.simple.util.storage.set(cacheKey, storage);
  },

  initGroupToggle() {
    const cacheKey = `${window.location.pathname}timeline_group_toggle`;
    const storage = window.simple.util.storage.get(cacheKey) || '';
    storage.split(',').forEach((id) => {
      const group = this.querySelector(`.sidebar-group[data-group-id="${id}"]`);
      if (group) this.toggleGroup(group);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
